import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=4ff1353e&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=4ff1353e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff1353e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ff1353e')) {
      api.createRecord('4ff1353e', component.options)
    } else {
      api.reload('4ff1353e', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=4ff1353e&scoped=true&", function () {
      api.rerender('4ff1353e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2B72eL5gGpKkp/JS/comp/PopupBox.vue"
export default component.exports